export const FrontEndRoutes = {
  INDEX: "/",
  LOGIN: "/login",
  HOME: "/home",
  DASHBOARD: "/dashboard",
  CLIENTES: {
    LIST: "/clientes",
    CREATE: "/clientes/novo",
    SHOW: "/clientes/:id",
    EDIT: "/clientes/:id/edit"
  },
  USUARIOS: {
    LIST: "/usuarios",
    CREATE: "/usuarios/novo",
    SHOW: "/usuarios/:id",
    EDIT: "/usuarios/:id/edit"
  },
  PRODUTOS: {
    LIST: "/produtos",
    CREATE: "/produtos/novo",
    SHOW: "/produtos/:id",
    EDIT: "/produtos/:id/edit",
  },
  TABELA: {
    PRECO: "/tabela/preco",
    CREATE: "/tabela/preco/novo",
    EDIT: "/tabela/preco/:id",
  },
  PEDIDOS: {
    LIST: "/pedidos",
    CREATE: "/pedidos/novo",
    SHOW: "/pedidos/:id",
    EDIT: "/pedidos/:id/edit",
  },
  FRENTE_DE_CAIXA: "/frente-de-caixa",
  CONFIG: "/config",
};
